"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArmsatImageryShowcase() {
  const {
    ref: s1TextRef,
    isVisible: s1TextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: s1ImgRef,
    isVisible: s1ImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: s2TextRef,
    isVisible: s2TextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: s2ImgRef,
    isVisible: s2ImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: s3TextRef,
    isVisible: s3TextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: s3ImgRef,
    isVisible: s3ImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="armsatimageryshowcase" className="text-white py-20 overflow-hidden md:py-32 light bg-secondary">
      <div className="container mx-auto px-4 md:px-6 space-y-24 md:space-y-40">
        
        {/* Բաժին 1 - Ավելացված է lg:items-start */}
        <div className="flex flex-col items-center lg:items-start gap-12 !m-0 ![padding:0px_0px_100px_100px] lg:flex-row lg:gap-20">
          <div ref={s1TextRef} className={`flex-1 space-y-6 transition-all duration-1000 transform ${s1TextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="text-2xl font-bold tracking-tight leading-tight !text-[rgba(25,19,53,1)] md:text-3xl lg:text-4xl">Մուլտիսպեկտրալ Արբանյակային պատկերներ 30սմ-1.5մ լուծաչափով<br /><span className="text-white/90" data-ast-id="f:/src/pages/SatelliteImageAcquisition/sections/ArmsatImageryShowcase.tsx|sig:kn91ew" data-ast-start="1633" data-ast-end="1833">30սմ-1.5մ լուծաչափով</span></h2>
            <p className="text-base leading-relaxed font-default !text-[rgba(25,19,53,1)] md:text-lg">
              Ստացեք աննախադեպ մանրամասնություն՝ ճշգրիտ քարտեզագրման, քաղաքաշինության, ենթակառուցվածքների մոնիթորինգի և անվտանգության կիրառությունների համար: Հարմար է միկրո մակարդակի վերլուծության և փոքրից միջին տարածքներում փոփոխությունների հայտնաբերման նպատակով: Մեր բարձր լուծաչափով տվյալները հնարավորություն են տալիս իրականացնել ակտիվների ճշգրիտ կառավարում և շրջակա միջավայրի մանրամասն գնահատում: Այսպիսի մանրամասնությունը ապահովում է կարևոր որոշումների կայացման գործընթացները, որտեղ տվյալների մանրամասնությունն առանցքային է, նպաստելով բարդ նախագծերի օպտիմալ պլանավորմանն ու իրականացմանը:
            </p>
          </div>
          <div ref={s1ImgRef} className={`flex-1 grid grid-cols-1 gap-6 transition-all duration-1000 delay-200 transform ${s1ImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/high_res_imagery_analysis_1.png" alt="High resolution satellite imagery analysis view 1" className="rounded-lg shadow-lg w-full h-auto object-cover border border-white/10" loading="lazy" src="https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_08-scaled.jpg" />
            
          </div>
        </div>

        {/* Բաժին 2 - Ավելացված է lg:items-start */}
        <div className="flex flex-col items-center lg:items-start gap-12 !bg-[rgba(71,66,93,0)] ![margin:0px_0px_100px_0px] lg:flex-row-reverse lg:gap-20">
          <div ref={s2TextRef} className={`flex-1 space-y-6 text-center lg:text-left transition-all duration-1000 transform ${s2TextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-2">
              <h2 className="text-2xl font-bold tracking-tight leading-tight !bg-[rgba(25,19,53,0)] !text-[rgba(25,19,53,1)] md:text-3xl lg:text-4xl">Բազմասպեկտր արբանյակային պատկերներ 2․5մ լուծաչափով Արմսաթ 1 արբանյակից</h2>
            </div>
            <p className="text-base leading-relaxed font-default !text-[rgba(60,57,85,1)] md:text-lg">
              Հիանալի ընտրություն է լայնամասշտաբ տարածքային մոնիտորինգի, գյուղատնտեսական հողերի վերլուծության, անտառային ռեսուրսների կառավարման և շրջակա միջավայրի ազդեցության գնահատման համար: Այն համատեղում է մանրամասնությունն ու լայն ընդգրկումը՝ ապահովելով ծախսարդյունավետ լուծումներ մեծ աշխարհագրական տարածքների համար: Օգտագործեք Արմսաթ 1-ի տվյալները հուսալի և հետևողական դիտարկումների համար: Այս պատկերները կարևոր են լայնածավալ օրինաչափությունների և միտումների հասկանալու համար՝ դարձնելով դրանք անփոխարինելի գործիք շրջակա միջավայրի պաշտպանության և ռեսուրսների կառավարման ոլորտներում:
            </p>
            <div className="pt-4">
              <Button asChild variant="outline" size="lg" className="border-white/20 hover:bg-white/10 text-white rounded-md">
                <Link to="/ArmsatPage">Իմանալ Ավելին</Link>
              </Button>
            </div>
          </div>
          <div ref={s2ImgRef} className={`flex-1 grid grid-cols-1 gap-6 transition-all duration-1000 delay-200 transform ${s2ImgVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_imagery_sample_1.png" alt="ARMSAT1 satellite imagery sample 1" className="rounded-lg shadow-lg object-cover border border-white/10 !w-[550px] !h-[550px]" loading="lazy" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image27.jpeg" />
            
          </div>
        </div>

        {/* Բաժին 3 - Ավելացված է lg:items-start */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-20">
          <div ref={s3TextRef} className={`flex-1 space-y-6 transition-all duration-1000 transform ${s3TextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="text-2xl font-bold tracking-tight leading-tight !bg-[rgba(71,66,93,0)] !text-[rgba(25,19,53,1)] md:text-3xl lg:text-4xl">
              Սինթետիկ ապերտուրայով ռադարային պատկերներ (SAR)
            </h2>
            <p className="text-base leading-relaxed font-default !bg-[rgba(70,65,92,0)] !text-[rgba(71,66,93,1)] md:text-lg">
              Անցեք ամպերի, մառախուղի և խավարի միջով՝ ստանալով կարևոր տվյալներ՝ անկախ եղանակային պայմաններից կամ օրվա ժամից: Անփոխարինելի է ծովային հսկողության, աղետների արձագանքման, երկրաբանական քարտեզագրման և մակերևույթի դեֆորմացիաների մոնիթորինգի համար: SAR տեխնոլոգիան ապահովում է եզակի պատկերացում մակերևույթի հատկությունների և փոփոխությունների վերաբերյալ, որոնք տեսանելի չեն օպտիկական սենսորներով: Նրա բացառիկ հնարավորությունները թույլ են տալիս իրականացնել շարունակական դիտարկում՝ զգալիորեն բարձրացնելով իրադրային իրազեկվածությունը բարդ միջավայրերում:
            </p>
          </div>
          <div ref={s3ImgRef} className={`flex-1 grid grid-cols-1 gap-6 transition-all duration-1000 delay-200 transform ${s3ImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/sar_imagery_orthophoto_1.png" alt="SAR Imagery orthophoto generation view 1" className="rounded-lg shadow-lg w-full h-auto object-cover border border-white/10" loading="lazy" src="https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_12-SAR-1-scaled.jpg" />
            
          </div>
        </div>

      </div>
    </section>;
}